// DEPRECATED: Используйте директиву @cian/config
export const addFormConfig = {
  editPath: window.runtime_settings && window.runtime_settings.EDIT_PATH || '/razmestit-obyavlenie/<offerId>/',
};
